import { type DefaultTheme } from '@mui/styles';
import { TRANSACTION_CATEGORY, type TRANSACTION_TYPE } from '../../History/types';
import { AddRounded, ClearRounded } from '@mui/icons-material';
import { styled } from '@mui/styles';

type MakeStylesProps = {
  category?: TRANSACTION_CATEGORY | TRANSACTION_TYPE.CREDIT;
};

export const CategoryWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: theme.spacing(1)
}));

export const CategoryIconWrapper = styled('div')<DefaultTheme, MakeStylesProps>(({ theme, category }) => ({
  width: theme.spacing(4),
  minWidth: theme.spacing(4),
  height: theme.spacing(4),
  background:
    category === TRANSACTION_CATEGORY.NOT_SUPPORTED
      ? theme.palette.transactions.category.background.notSupported
      : theme.palette.transactions.category.background.supported,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const NotSupportedCategoryIconWrapper = styled(ClearRounded)(({ theme }) => ({
  fontSize: '19px',
  color: theme.palette.error.main
}));

export const RefundCategoryIconWrapper = styled(AddRounded)(({ theme }: { theme: any }) => ({
  fontSize: '19px',
  color: theme.palette.alerts.info.color
}));
